import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { RespuestaValidaPago } from 'src/app/global/enums/respuesta-valida-pago.enum';
import { AnexoContratoResponse } from 'src/app/global/interfaces/anexo-contrato-response';
import { ObtenerUrlPagoResponse } from 'src/app/global/interfaces/obtener-url-pago-response';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { AnexoContratoServiceVM } from 'src/app/view-model/services/anexo-contrato.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { PayProcessServiceVM } from 'src/app/view-model/services/pay-process.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { SiguientesPasosServiceVM } from 'src/app/view-model/services/siguientes-pasos-vm.service';
import { ValidacionEdicionServiceVM } from 'src/app/view-model/services/validacion-edicion.service';
import { ValidacionCIPreFirmaVM } from '../validacion-ci-prefirma/validacion-ci-prefirma.provider';
import _ from 'lodash';

@Injectable()
export class PayProcessProviderVM extends PayProcessServiceVM {
    public anexosAceptar: AnexoContratoResponse;
    public urlPagoResponse :ObtenerUrlPagoResponse;
    private product: Product;
    private wixStatus: boolean;
    private DOCUMENTO_YA_APROBADO = 'DOCUMENTO_YA_APROBADO';

    constructor(
        private anexoContratoService: AnexoContratoServiceVM,
        private productoVM: vmProductosService,
        private router: Router,
        private carroService: CarroComprasService,
        private store: LocalStorageService,
        private valEdicionService: ValidacionEdicionServiceVM,
        private sigPasosService: SiguientesPasosServiceVM,
        private validaCi:ValidacionCIPreFirmaVM
        
    ) {
        super();
    }

    public async payProcess(wixStatus: boolean): Promise<any> {
        try {
            this.product = this.carroService.getCurrentProduct();
            this.wixStatus = wixStatus;
            const anexosAceptar = await this.getObtieneAnexos();
            let statusFirma: boolean = anexosAceptar.data.firmado;
            if (!statusFirma) {
                statusFirma = await this.anexoContratoService.aprobarAnexo(anexosAceptar).catch(async e => {
                    if (e.error.indicador === this.DOCUMENTO_YA_APROBADO) {
                        statusFirma = true;
                        return;                      
                    } 
                    const contenido = _.get(e,'error.mensaje.contenido','');
                    const estadoValidacionCI = await this.validaCi.assertCedulaIdentidadVigente(contenido);                 
                    if(estadoValidacionCI ==='VALIDADO'){
                        await this.payProcess(wixStatus).catch(ee=>{throw ee});
                        return;
                    }
                    
                    throw e;
                });

            }
            this.sleep(1000);
            if (statusFirma) {
                const validStepThree: any = await this.valEdicionService.getValidacionEdicion().toPromise();
                const stepThreeLocalStore = this.store.getPaso3();
                stepThreeLocalStore.validaPaso3 = validStepThree;
                this.store.setPaso3(stepThreeLocalStore);
                return this.activityToNow();
            } else {
                return 'Anexo no firmado';
            }
        } catch (error) {
            console.error(`error`, error);
        }
    }

    public async validaPagoEjecutivo(): Promise<boolean> {
        const response = await this.productoVM.validaPagoProducto().catch(e => {
            console.error(e);
            return e;
        });
        return response;
    }

    private sleep(ms) {
        return new Promise(resolve => {
            setTimeout(resolve, ms);
        });
    }

    private async activityToNow(): Promise<any> {
        const response = await this.productoVM.validaPagoProducto().catch(e => {
            console.error(e);
            return e;
        });
        if (response === RespuestaValidaPago.CONTINUAR_RESUMEN) {
            const pasos = await this.sigPasosService.obtenerSiguientesPasos().toPromise();
            const dataPaso3 = this.store.getPaso3();
            dataPaso3.siguientePaso = pasos;
            this.store.setPaso3(dataPaso3);
            this.router.navigate(['generacion-proceso']);
        } else if (response === RespuestaValidaPago.URL_PAGO) {
            return await this.goPay();
        } else if (response === RespuestaValidaPago.AGENDAR_FECHA) {
            return response;
        }
    }

    private async goPay(): Promise<void> {
        try {
            if (((this.product.codigoProducto === CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX || this.product.codigoProducto === CodigoProductoEnum.VENTA_MPOS
                || this.product.codigoProducto === CodigoProductoEnum.VENTA_MPOS_GARANTIA || this.product.codigoProducto === CodigoProductoEnum.PACK_VENTA_MPOS_LP
                || this.product.codigoProducto === CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA) && this.wixStatus) || (this.product.codigoProducto !== CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX
                    && this.product.codigoProducto !== CodigoProductoEnum.VENTA_MPOS && this.product.codigoProducto !== CodigoProductoEnum.VENTA_MPOS_GARANTIA
                    && this.product.codigoProducto != CodigoProductoEnum.PACK_VENTA_MPOS_LP && this.product.codigoProducto != CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA)) {
                const data = await this.productoVM.obtenerUrlPago()
                    .catch(e => {
                        console.error(`e`, e);
                        return e.error.mensaje;
                    });
                if (data.urlPago) {
                    window.location.href = data.urlPago;
                } else {
                    return data;
                }
            } else {
                this.router.navigate(['/resumen-compra']);
            }
        } catch (error) {
            console.error(`error en goPay`, error);

        }
    }

    /* private async goPay(): Promise<boolean> {
        try {
            if (((this.product.codigoProducto === CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX || this.product.codigoProducto === CodigoProductoEnum.VENTA_MPOS || this.product.codigoProducto === CodigoProductoEnum.VENTA_MPOS_GARANTIA) && this.wixStatus) 
                || (this.product.codigoProducto !== CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX && this.product.codigoProducto !== CodigoProductoEnum.VENTA_MPOS && this.product.codigoProducto !== CodigoProductoEnum.VENTA_MPOS_GARANTIA)) {
                    const urlPagoResponse = await this.productoVM.obtenerUrlPago()
                    .catch(e => {
                        console.error(`e`, e);
                        return e.error.mensaje;
                    });
                if(urlPagoResponse.isEjecutivo ){
                    if(urlPagoResponse.isCorreoOk){
                        return true;
                    }
                    return false;
                }else if (!urlPagoResponse.contenido){
                    window.location.href = urlPagoResponse.urlPago;
                }
                return false;
            } else {
                this.router.navigate(['/resumen-compra']);
                return true;
            }
        } catch (error) {
            console.error(`error en goPay`, error);

        }
    } */

    private async getObtieneAnexos(): Promise<any> {
        return await this.anexoContratoService.getAnexoContrato().toPromise();
    }
}
